import React from 'react'
import { Link } from 'react-router-dom'

type Props = {
  backgroundImage: string
  title: React.ReactNode
  bullets: string[]
  button: React.ReactNode
}

export const CategoryTeaser: React.FC<Props> = (props) => (
  <section className="categoryteaser" style={{ backgroundImage: `url('${props.backgroundImage}')` }}>
    <div className="categoryteaser-content" style={{ minHeight: '320px' }}>
      <h2 className="categoryteaser-title helper-nocase">{props.title}</h2>
      <ul className="categoryteaser-labels">
        {props.bullets.map((bullet) => (
          <li key={bullet}>{bullet}</li>
        ))}
      </ul>
      <footer className="categoryteaser-footer">
        <div className="grid-row">
          <div className="grid-span12">{props.button}</div>
        </div>
      </footer>
    </div>
  </section>
)

export const CategoryTeaserButton: React.FC<React.ComponentProps<typeof Link>> = (props) => (
  <Link {...props} className="button grid-gap0-below" />
)
